// Facets
(() => {
  const desktopSortByLabels = document.querySelectorAll('.facets-sidebar .accordion__content-sort-by label');

  function sortBy(evt) {
    evt.preventDefault();

    const facets = evt.target.closest('.facets');
    const url = new URL(window.location.href);

    url.searchParams.set('sort_by', evt.target.dataset.value);
    url.searchParams.delete("page");
    url.searchParams.set('section_id', facets.getAttribute('section-id'));

    facets.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: {
        url
      }
    }));
  };

  function changeSelectedSortBy(evt) {
    const target = evt.target.nodeName === 'INPUT' ? evt.target.closest('label') : evt.target;

    document.querySelectorAll('.facets-drawer .accordion__content-sort-by label').forEach((item) => {
      item.removeAttribute('is');
    });

    target.setAttribute('is', 'selected');
  }

  function attachSortBy() {
    desktopSortByLabels.forEach((item) => {
      item.addEventListener('click', sortBy);
    });
  }

  function attachChangeSelectedSortBy() {
    document.querySelectorAll('.facets-drawer .accordion__content-sort-by label').forEach((item) => {
      item.addEventListener('click', changeSelectedSortBy);
    });
  }

  const desktopObserver = new MutationObserver(attachSortBy);
  desktopObserver.observe(document.querySelector('.shopify-section--main-collection'), { childList: true });

  const mobileObserver = new MutationObserver(attachChangeSelectedSortBy);
  mobileObserver.observe(document.documentElement || document.body, { attributes: true, childList: true, characterData: true });

  attachSortBy();
  attachChangeSelectedSortBy();
})();

// Banner
(() => {
  const section = document.querySelector('.shopify-section--image-with-text-overlay');

  if (!section) {
    return;
  }

  document.querySelector('.collection__main')?.appendChild(section);
})();